<template>
  <div v-if="!loading">
    <div class="actions mb-2">
      <slot name="actions" />
    </div>
    <div v-if="listing.is_approval_data" class="rounded-full py-2 px-4 bg-red-lightest mb-2">
      <p class="text-red">You are viewing a draft version you current live version will not be affected until you draft version is reviewed and approved by the head office</p>
    </div>
    <form @submit="save" class="news-section">
      <div class="mb-4 p-4">
        <label class="label-xs">
          Article Title
        </label>
        <input
          v-model="listing.title"
          type="text"
          class="input-sm w-full"
          required>
        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('title')" v-text="errorBag.get('job_title')"></small>
      </div>
      <div class="mb-4 flex w-full">
        <div class="w-1/2 p-4">
          <label class="label-xs">
            Article Short Description
          </label>
          <textarea
            maxlength="512"
            v-model="listing.short_description"
            type="text"
            class="input-sm w-full h-full"
            rows="3"
            required>
          </textarea>
        </div>
        <div class="w-1/2 p-4">
          <label class="label-xs">
            Article Featured Image
          </label>
          <div
          class="relative flex items-end justify-center w-full h-full bg-grey-lighter border bg-center bg-cover bg-no-repeat"
          :style="{ backgroundImage: `url(${listing.image_url})` }"
        >
        <button
            type="button"
            class="absolute z-20 cursor-pointer pin-t pin-r h-6 w-6 flex items-center justify-center -m-2 bg-white text-black rounded-full border shadow"
            @click.stop="removeImage"
          >
            <i class="fas fa-times fa-fw fa-xs" />
          </button>
          <span class="relative mb-4 w-3/5 text-center text-sm text-grey-light font-bold">
            <i class="fas fa-camera"></i>
            <br>
            Drop an image to change
          </span>
          <input type="file" name="image" id="image" accept="image/*" class="absolute w-full h-full opacity-0 cursor-pointer" @change="imageChanged">
        </div>
        </div>
      </div>
      <div class="mb-4 p-4">
        <label class="label-xs">
          Description
        </label>
        <tinymce
          :init="editorConfig"
          v-model="listing.description.content"
          @onChange="onTinyMceContentChange"
        />
      </div>
      <div class="mb-4">
        <label class="label-xs">
          Select Category
        </label>
        <select-input
          v-model="listing.category"
          :options="category"
        />
      </div>
      <div class="mb-4">
        <label class="label-xs">
          Associated Offices
        </label>
        <select-input
          v-model="listing.selectedOffices"
          :options="officeList"
        />
      </div>
      <div class="mb-4 flex w-full">
        <div class="w-1/2 p-4">
          <label class="label-xs">
            SEO Title (Optional)
        </label>
        <input
          v-model="listing.seo_title"
          type="text"
          class="input-sm w-full"
          required>
        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('seo_title')" v-text="errorBag.get('contact_number')"></small>
        </div>
        <div class="w-1/2 p-4">
          <label class="label-xs">
          SEO Description (Optional)
        </label>
        <input
          v-model="listing.seo_description"
          type="text"
          class="input-sm w-full"
          required>
        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('seo_description')" v-text="errorBag.get('contact_number')"></small>
        </div>
      </div>
      <div class="flex w-full p-4">
        <div class="px-3">
          <input type="checkbox" id="contentRights" v-model="listing.confirm_rights" />
          <label for="contentRights" class="whitespace-normal">I confirm that the articles is their own and that any images used they have the rights to use the image commercially on websites</label>
        </div>
      </div>
      <div class="flex w-full justify-end p-4">
        <div>
          <button type="submit" class="bg-tertiary text-white py-2 px-6 rounded" :disabled="saving">
          <i v-if="saving" class="fas fa-circle-notch fa-fw fa-lg fa-spin" />
          <span v-else>Save</span>
        </button>
        </div>
      </div>
    </form>
  </div>

  <loader v-else class="my-10" />
</template>

<script>
import api from '@/http'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import ErrorBag from '@/ErrorBag'
import mceConfig from '@/mixins/TinyMCE'

export default {
  mixins: [ mceConfig ],
  props: ['listing'],

  data () {
    return {
      loading: false,
      saving: false,
      imageFile: null,
      category: [],
      errorBag: new ErrorBag()
    }
  },

  computed: {
    ...mapState(['profile', 'selectedOffice', 'userOfficeList']),

    officeList () {
      let array = []
      for (let i = 0; i < this.userOfficeList.length; i++) {
        array.push({
          id: this.userOfficeList[i].id,
          name: this.userOfficeList[i].name + '(' + this.userOfficeList[i].address_town + ')'
        })
      }
      return array
    }
  },
  created () {
    this.load()
  },
  methods: {
    ...mapActions(['displayToastNotification']),

    moment: moment,
    load () {
      this.getCategory()
    },
    getCategory () {
      api.get('/website-news/category')
        .then(response => {
          this.category = response.data
        })
    },
    imageChanged (e) {
      let file = e.target.files[0]
      this.listing.image_url = URL.createObjectURL(file)
      this.listing.featured_image = file
    },

    removeImage () {
      this.listing.featured_image = null
      this.listing.image_url = null
    },
    onTinyMceContentChange (event, editor) {
      let content = editor.getContent()
      let emptyListItem = '<li>&nbsp;</li>'
      if (content.includes('mce-toc') && content.includes(emptyListItem)) {
        content = content.replace(new RegExp(emptyListItem, 'g'), '')
        if (typeof content === 'string' && content.length !== 0) {
          editor.setContent(content)
        }
      }
    },
    async save (e) {
      e.preventDefault()
      if (this.listing.selectedOffices.length < 1) {
        this.displayToastNotification({
          type: 'danger',
          icon: 'fa-times',
          title: 'Please select office'
        })
        return
      }
      this.saving = true

      let formData = new FormData()
      let route = '/website-news/' + this.selectedOffice.id
      if (this.listing.id) {
        route += `/${this.listing.id}/update`
        formData.append('_method', 'PATCH')
      }

      for (var key in this.listing) {
        let value = this.listing[key]
        if (key === 'description') {
          formData.append(key, JSON.stringify(value))
          console.log('is array converting to json desc')
          continue
        }
        if (Array.isArray(value)) {
          formData.append(key, JSON.stringify(value))
          continue
        }
        formData.append(key, value)
      }

      this.errorBag.clear()
      api.post(route, formData)
        .then(response => {
          // this.listing = response.data
          this.imageUrl = response.data.featured_image
          this.saving = false
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Saved',
            info: `News has been successfully saved.`
          })
          this.$emit('saved')
        }, (errors) => {
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times',
            title: 'Unable to save News',
            info: errors.response.data.message
          })
          this.errorBag.store(errors.response.data)
          this.saving = false
        })
    }
  }
}
</script>

<style lang="sass" scoped>
</style>

<style lang="sass">
.application-description .ProseMirror
  @apply min-h-32
</style>
